var _defs, _circle, _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransporter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "transporterJrPanel",
    "data-name": "transporter Jr Panel",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Transporter-cls-1{fill:#14163d;}.Transporter-cls-2{fill:#efff2b;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "Transporter-cls-1",
    cx: 75,
    cy: 75,
    r: 75
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "Transporter-cls-2",
    points: "27.86 49.29 81.43 42.86 72.86 30 122.14 49.29 75 70.71 81.43 55.71 27.86 49.29"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "Transporter-cls-2",
    points: "124.29 98.57 70.71 105 79.29 117.86 30 98.57 77.14 77.14 70.71 92.14 124.29 98.57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransporter);
export default __webpack_public_path__ + "static/media/Transporter.8cf86bfeea3b7834d1b2b59ea06c3a0c.svg";
export { ForwardRef as ReactComponent };